/**
 * PH (菲律宾) 校验规则覆写
 * 命名规则同 diffconfig/config/validators.ts：moduleFieldName（小驼峰）
 */
export const FIELD_RULES: Record<string, any[]> = {}
